var sparks = require('../../chat/chat-sparks');
var config = require('../../config').config;
var modal = require('../modal-static');
var notices = require('../../notices');
var raygun = require('../../raygun');

function sendVirtualGift(e) {
    var item = e.target.closest('[data-modal-virtual-gift]')
    if (item) {
        e.stopImmediatePropagation()
        
        sparks.giveGift(item.dataset.modalId, config.translationPath, config, item.dataset.modalVirtualGift)
            .then(function (res) {
                //close modal
                modal.destroy();
                if (res.dataset) {
                    sparks.updateSparksBalance(res)
                    //fake click again to start chat
                    var ev = new Event('launchimCustomEvent', { bubbles: true })
                    ev.chatmemberid = item.dataset.modalId
                    document.dispatchEvent(ev)

                    //if we have a redirect attribute
                    if (item.dataset.modalVirtualGiftRedirect === 'true') {
                        //redirect the user to the chat
                        location = location.origin+"/"+config.translationPath+"/mail/showemail?mid="+item.dataset.modalId
                    }

                    if (res.message) {
                        notices.confirm(res.message)
                    }
                } else {
                     // issue with sending gift
                     if ("message" in res) {
                        // show user warining notice
                        notices.warn(res.message)
                    } else {
                        // follow redirect link
                        window.location = res.redirect ? res.redirect : res.redirectLink
                    }
                }
            })
            .catch(function (error) {
                raygun.sendError(error, 'modalVirtualGifts');
        })
    }
    
}

document.addEventListener('click', sendVirtualGift, true)